export default "__VITE_ASSET__832df373__"